var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCabinetProjectDestributionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.5V12.8313C5.625 16.8 5.625 18.785 6.84625 20.0175C8.06625 21.25 10.03 21.25 13.9587 21.25H16.0425C19.97 21.25 21.9337 21.25 23.155 20.0175C24.375 18.7838 24.375 16.8 24.375 12.8313V7.5M5.625 7.5H24.375M5.625 7.5L6.52625 5.5775C7.22625 4.085 7.57625 3.34 8.28375 2.92C8.9925 2.5 9.9 2.5 11.7187 2.5H18.2812C20.0987 2.5 21.0075 2.5 21.7162 2.92C22.425 3.34 22.775 4.085 23.4737 5.5775L24.375 7.5M13.125 11.25H16.875M5 27.5H15M15 27.5H25M15 27.5V24.375",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCabinetProjectDestributionIcon);
export default __webpack_public_path__ + "static/media/lp_cabinet_project_destribution_icon.f953c0223d4c146be5dc031247126a09.svg";
export { ForwardRef as ReactComponent };